import React from "react";
import ParticlesBg from 'particles-bg'

import "./App.css";
import Main from "./component/Main.jsx";
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";

function App() {
  return (
    <div className="App">
      <Router>
        <Route component={Main} />
      </Router>
      <ParticlesBg num={5} type="ball" bg={true} style={{position: "absolute",
      zIndex: -1,
      top: 0,
      left: 0
      }} />
    </div>
  );
}

export default App;
